import Vue from 'vue'
import Vuex from 'vuex'
import { i18n } from '@/localization'

import axios from '@/services/axios'

Vue.use(Vuex)

export default {
  LOGIN ({ commit, rootState }, { email, password }) {
    const { app } = rootState
    commit('SET_STATE', {
      loading: true,
    })

    return axios.post('/users/login', {
      user_email: email,
      user_password: password,
      user_role: app.type,
      vendor_name: app.name,
    })
      .then(({ data }) => {
        commit('LOGIN', {
          token: data.token,
        })
        commit('SET_STATE', {
          role: data.user.role,
          id: data.user.id,
          email,
          name: data.user.name,
        })
        return {
          success: true,
          response: data,
        }
      })
      .catch(err => {
        console.log({ err })
        const { response } = err
        let message = null

        if (response) {
          switch (response.status) {
            case 401:
              message = i18n.t('authForm.invalidPassword')
              break

            case 404:
              message = i18n.t('authForm.emailNotFound')
              break

            default:
              message = i18n.t('authForm.systemBusy')
              break
          }
        }

        return {
          success: false,
          code: response?.status,
          message,
        }
      })
      .finally(() => {
        commit('SET_STATE', {
          loading: false,
        })
      })
  },

  FORGOTPASS ({ commit, rootState }, { email }) {
    const { app } = rootState
    commit('SET_STATE', {
      loading: true,
    })
    return axios.put('/users/passwd', {
      user_email: email,
      user_role: app.type,
      vendor_name: app.name,
    },
    {
      headers: {
        storeId: app.vendor_hashid,
      },
    })
      .then(({ data }) => {
        commit('SET_STATE', {
          email: data.user_email,
          confirmpass: {
            link: data.link,
          },
        })
        return {
          success: true,
          response: data,
        }
      })
      .catch(err => {
        const { response } = err
        let message = null

        if (response) {
          switch (response.status) {
            case 404:
              message = i18n.t('authForm.emailNotFound')
              break

            default:
              message = i18n.t('authForm.systemBusy')
              break
          }
        }
        return {
          success: false,
          code: response?.status,
          message,
        }
      })
      .finally(() => {
        commit('SET_STATE', {
          loading: false,
        })
      })
  },
  RESETPASSWRD ({ commit, rootState }, { payload }) {
    const { password, confirmpassword } = payload
    const { user } = rootState
    const { link, token } = user.confirmpass
    const tokenbar = `Bearer ${token}`
    commit('SET_STATE', {
      loading: true,
    })
    return axios.put('/users/private/resetpasswd', {
      register_link: link,
      new_password: password,
      confirm_password: confirmpassword,
    },
    {
      headers: {
        Authorization: tokenbar,
      },
    })
      .then(({ data }) => {
        commit('LOGIN', {
          token: data.token,
        })
        commit('SET_STATE', {
          role: data.user.role,
          id: data.user.id,
          name: data.user.name,
        })
        return {
          success: true,
          response: data,
        }
      })
      .catch(err => {
        const { response } = err
        let message = null
        if (response) {
          switch (response.status) {
            case 422:
              message = i18n.t('authForm.passwrdNotmatch')
              break

            case 404:
              message = 'storeId unknown!'
              break

            default:
              message = i18n.t('authForm.systemBusy')
              break
          }
        }
        return {
          success: false,
          code: response?.status,
          message,
        }
      })
      .finally(() => {
        commit('SET_STATE', {
          loading: false,
        })
      })
  },

  LOGOUT({ commit, rootState }) {
    commit('SET_STATE')
  },

  async changePassword(_, { password, new_password, confirm_password }) {
    try {
      const { data: response } = await axios.put('/users/private/passwd', {
        password,
        new_password,
        confirm_password,
      })

      return Promise.resolve(response)
    } catch (err) {
      return Promise.reject(err)
    }
  },
}
